/**
 * Funzioni API per le impostazioni SSO Microsoft Entra ID (Admin — product-service, TC_AUTH_PROVIDER=entra).
 *
 * Endpoint:
 *   GET /api/products/admin/sso  → SsoSettings (solo SYSTEM_CONFIGURATION)
 *   PUT /api/products/admin/sso  → SsoSettings (solo SYSTEM_CONFIGURATION)
 */
import { createServiceClient } from '../../api/client.js';

const productApi = createServiceClient('product');

/** Valore di un claim Entra (object ID di gruppo o App Role) → ruolo TC. */
export interface SsoRoleMapping {
  claim: string;
  role: string;
}

export interface SsoSettingsInput {
  enabled: boolean;
  tenantId: string | null;
  clientId: string | null;
  roleMappings: SsoRoleMapping[];
  /** Ruolo per chi non ha alcun mapping; null = accesso negato. */
  defaultRole: string | null;
}

export interface SsoSettings extends SsoSettingsInput {
  /** admin = salvato da /admin; env = seed SSO_ENTRA_*; default = mai configurato. */
  source: 'admin' | 'env' | 'default';
  updatedAt?: string;
  updatedBy?: string;
  breakGlassConfigured: boolean;
  /** Issuer dei JWT coniati dal product-service. */
  issuer: string;
  scopes: string[];
}

export function fetchSsoSettings(): Promise<SsoSettings> {
  return productApi<SsoSettings>('/admin/sso');
}

export function updateSsoSettings(input: SsoSettingsInput): Promise<SsoSettings> {
  return productApi<SsoSettings>('/admin/sso', { method: 'PUT', body: input });
}
